import vendorConfig from '../vendorConfig.ts'

export const DEFAULT_TEMPLATE_ID = 'baseline'

export type TemplateDefinition = {
  id: string
  label: string
  status: 'production' | 'development'
  zendeskScript?: string
}

const definitions = [
  {
    id: DEFAULT_TEMPLATE_ID,
    label: 'Baseline',
    status: 'production',
    zendeskScript: vendorConfig.zendesk.script,
  },
  {
    id: 'var1',
    label: 'Var 1',
    status: 'production',
  },
] as const satisfies readonly TemplateDefinition[]

export type TemplateId = typeof definitions[number]['id']
type Template = Omit<TemplateDefinition, 'id'> & { id: TemplateId }

export const templates: readonly Template[] = definitions

export const productionTemplates = templates.filter((template) => template.status === 'production')

export const resolveTemplate = (templateId?: string | null, productionOnly = false): Template => {
  const available = productionOnly ? productionTemplates : templates

  return available.find((template) => template.id === templateId)
    ?? definitions[0]
}

export const resolveZendeskScript = (templateId?: string | null, productionOnly = false): string => {
  const template = resolveTemplate(templateId, productionOnly)

  return template.zendeskScript || definitions[0].zendeskScript
}
